























import blockMixin from './../BlockMixin.vue'
import uploadMixin from './../UploadMixin.vue'

export default {
  name: 'single-image'

  mixins: [blockMixin, uploadMixin]

  props: ['disallowAllignment']

  data: -> {
    fields: {
      alt: ''
      image: ''
      image_id: ''
      alignment: 'center'
    }
  }

  mounted: ->
    vm = this

    # TODO: brrr…
    this.$el.querySelector('.bb8-block-image-fileinput').click() if this.block.fields.image.length <= 0

    # TODO: Is there a better solution to handle cancelling a file input dialog?
    window.addEventListener('focus', (event) ->
      setTimeout(->
        vm.onFileInputCancel()
      , 100)
    )

  methods: {
    onFileInputCancel: ->
      this.removeBlock() if this.block.fields.image.length <= 0 && this.$el.querySelector('.bb8-block-image-fileinput').files.length <= 0

    updateImage: (event) ->
      this.uploadImage(event)

    setAlignment: (alignment) ->
      this.fields.alignment = alignment

    removeBlock: ->
      this.$emit('remove-block', this.index)
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/blocks/ImageBlock.vue